import React, { Fragment, useState, useContext } from "react";
import * as VS from "../../Services/ValidatorService";
import * as RS from "../../Services/RenderService";
import * as MS from "../../Services/MenuService";
import * as Const from "../../_Const";
import * as AuthService from "../../Services/AuthService";
import Avatar from "@material-ui/core/Avatar";
import { MDBRow, MDBCol } from "mdbreact";
import { Link } from "react-router-dom";

async function submitHandler(event) {
  if (VS.handleSubmit(event, data, validateFormItem, validateChildComponent, false)) {
    try {
      await AuthService.login(data.email, data.password);
      window.location = "/";
    } catch (ex) {
      let error = "Nastala chyba při přihlašování";
      console.log(ex.response);
      if (ex.response) {
        if (ex.response.status == 400) {
          error = "Nastala chyba při přihlašování:\nZaslaná data osahují chybu.";
        } else if (ex.response.status == 409) {
          error = "Nastala chyba při přihlašování:\nUživatel s tímto emailem již existuje.\nVyplňte jiný email a akci opakujte.";
        } else if (ex.response.status == 500) {
          error = "Nastala chyba při přihlašování";
        }
      }

      if (error) {
        RS.toastError(error);
      }
    }
  }
}

function validateChildComponent() {
  return true;
}

function changeHandler(event) {
  const { name, value } = event.target;
  validateFormItem(name, value);
}

function validateFormItem(name, value) {
  let errors = data.errors;
  switch (name) {
    case "password":
      errors[name] = VS.min(value, 8, "Heslo");
      break;
    case "email":
      errors[name] = VS.validateEmail(value);
      break;
  }

  setData({ ...data, errors, [name]: value });
}

function getViewFromModel() {
  let model = {
    email: "",
    password: "",
    errors: {
      email: "",
      password: "",
    },
  };

  return model;
}

let [data, setData] = [2];
function PageLogin(props) {
  [data, setData] = useState(getViewFromModel());

  return (
    <div class="login-container justify-content-center">
      <div className="my-auto">
        <form onSubmit={submitHandler} noValidate>
          <MDBRow className="login-control-item">
            <MDBCol md="12">
              <Avatar className="login-avatar mx-auto">
                <i class="fas fa-user-lock"></i>
              </Avatar>
              <h1 className="text-center mt-2">WebDoOrdinace.cz</h1>
              <h5 className="text-center mt-2 mb-4 text-black-50">přihlášení do administrace</h5>
            </MDBCol>
          </MDBRow>
          <MDBRow className="login-control-item">
            <MDBCol md="12">{RS.renderInputText("email", "Email", data, changeHandler)}</MDBCol>
          </MDBRow>
          <MDBRow className="login-control-item mt-2">
            <MDBCol md="12">{RS.renderInputPassword("password", "Heslo", data, changeHandler)}</MDBCol>
          </MDBRow>
          <MDBRow className="mt-3 mb-2 login-control-item">
            <MDBCol md="12">
              <div className="container flex-fill">{RS.renderSubmitTextWithoutIcon("Příhlásit do administrace", false, "login-button ml-0")}</div>
            </MDBCol>
          </MDBRow>
          {/* <MDBRow className="mt-3  text-center">
            <MDBCol md="12">
              <div className="text-black-50 small">
                Némáte ještě vytvořený účet? <Link to={MS.getLinkFromMenuId(Const.ID_ACCOUNT_REGISTER)}>Zaregistrujte se</Link>
              </div>
            </MDBCol>
          </MDBRow> */}
          {/* <MDBRow className="mt-2 text-center">
            <MDBCol md="12">
              <div className="text-black-50 small">
                Zapoměli jste heslo? <Link to={MS.getLinkFromMenuId(Const.ID_ACCOUNT_FORGOT_PASSWORD)}>Obnovte jej</Link>
              </div>
            </MDBCol>
          </MDBRow> */}
        </form>
      </div>
    </div>
  );
}

export default PageLogin;
